import { render } from "./SendoutReport.vue?vue&type=template&id=2a21eb6c"
import script from "./SendoutReport.vue?vue&type=script&lang=js"
export * from "./SendoutReport.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/reports/SendoutReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a21eb6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a21eb6c', __exports__)) {
    console.log('reload')
    api.reload('2a21eb6c', __exports__)
  }
  
  module.hot.accept("./SendoutReport.vue?vue&type=template&id=2a21eb6c", () => {
    console.log('re-render')
    api.rerender('2a21eb6c', render)
  })

}


export default __exports__